export const USER_LOGGINED_IN_KEY_PREFIX = 'wordpress_logged_in_';

export const SESSION_KEY_PREFIX = 'wp_woocommerce_session_';
export const CART_ITEM_KEY = 'woocommerce_items_in_cart';

export const CURRENCY_KEY = 'aelia_cs_selected_currency';
export const COUNTRY_KEY = 'bft_selected_country';
export const LANGUAGE_KEY = 'user_language';

export const WISHLIST_GUEST_USER_COOKIE_KEY = 'ss_wishlist_customer_key';
export const WISHLIST_DATA_COOKIE_KEY = 'ss_wishlist_data';

export const RECENTLY_VIEWED_PRODUCTS_KEY = 'woocommerce_recently_viewed';

/**
 * Traffic origin information for the visitor’s current visit to your store
 */
export const WOOCOMMERCE_SBJS_CURRENT_COOKIE_KEY = 'sbjs_current';
/**
 * Timestamp, referring URL, and entry page for your visitor’s current visit to your store
 */
export const WOOCOMMERCE_SBJS_CURRENT_ADD_COOKIE_KEY = 'sbjs_current_add';

/**
 * The number of page views in this session and the current page path
 */
export const WOOCOMMERCE_SBJS_SESSION_COOKIE_KEY = 'sbjs_session';
/**
 * Information about the visitor’s user agent, such as IP, the browser, and the device type
 */
export const WOOCOMMERCE_SBJS_UDATA_COOKIE_KEY = 'sbjs_udata';

/**
 * Traffic origin information for the visitor’s first visit to your store (only applicable if the visitor returns before the session expires)
 */
export const WOOCOMMERCE_SBJS_FIRST_COOKIE_KEY = 'sbjs_first';

/**
 * Timestamp, referring URL, and entry page for your visitor’s first visit to your store (only applicable if the visitor returns before the session expires)
 */
export const WOOCOMMERCE_SBJS_FIRST_ADD_COOKIE_KEY = 'sbjs_first_add';

/**
 * Technical data to help with migrations between different versions of the tracking feature
 */
export const WOOCOMMERCE_SBJS_MIGRATIONS_COOKIE_KEY = 'sbjs_migrations';
